import type { DefaultTheme } from 'styled-components';

import { Primary, PrimaryDark } from './Palettes/index.ts';

export type ThemeId = 'primary' | 'primaryDark';

export const palette: Record<ThemeId, DefaultTheme> = {
  primary: Primary,
  primaryDark: PrimaryDark,
} as const;
